module.exports = __webpack_public_path__ + "static/media/p208model4.ba2bc5c8.jpg";